export const isValidMobile = (mobile) => {
  const mobileRegex = /^\d{10}$/;
  if (!mobileRegex.test(mobile)) {
    return "Invalid Mobile No";
  }
  return "";
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (email) => {
  let valid = emailRegex.test(email);
  return valid ? "" : "Invalid Email";
};

export const isValidPassword = (password) => {
  const errorS = [];
  if (password.length < 8) {
    errorS.push("8 characters");
  }
  if (!/[a-z]/.test(password)) {
    errorS.push("one lowercase letter");
  }
  if (!/[A-Z]/.test(password)) {
    errorS.push("one uppercase letter");
  }
  if (!/\d/.test(password)) {
    errorS.push("one numberical digit");
  }
  if (!/[@$!%*?&]/.test(password)) {
    errorS.push("one special character");
  }
  if (errorS.length > 0) {
    return `Password must have at least [${errorS.join(", ")}]`;
  }
  return "";
};

export const isValidPan = (pan) => {
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  if (!panRegex.test(pan)) {
    return "Invalid PAN No"
  }
  return ""
};

export const isValidAadhar = (aadhar) => {
  const aadharRegex = /^\d{12}$/;
  if (!aadharRegex.test(aadhar)) {
    return "Invalid Aadhar No"
  }
  return ""
};

export function filterEmptyValues(obj) {
  // Create a new object to store filtered key-value pairs
  const filteredObj = {};

  // Iterate over the keys of the input object
  for (const key in obj) {
    // Check if the value is not null, undefined, or an empty string
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
      // Add the key-value pair to the filtered object
      filteredObj[key] = obj[key];
    }
  }

  // Return the filtered object
  return filteredObj;
}
